import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Layout, Modal, Row, Select, Space, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import Header from '../../common/compornents/layout/header/Header';
import {
  notificationError,
  notificationInfo,
  notificationSuccess,
} from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import NonyusakiMaintenanceServ from '../../services/NonyusakiMaintenanceServ';
import TokuisakiServ from '../../services/TokuisakiServ';

const { Option } = Select;
const { Footer } = Layout;

// 引数
interface IProps {
  // Modal表示用state
  visibleState: boolean;

  hensyuMode: any;
  nouCd?: number;

  // 関数
  closeNonyusakiMaintenance: () => void;
}

const DeliveryMaintenance: React.FC<IProps> = (props: IProps) => {
  // セッション情報
  const tokCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) ?? '';
  const tokCd2 = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) ?? '';
  const companyCode = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD) ?? '';
  const accountId = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '';
  const companyName = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  const manager = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  const [form] = Form.useForm();
  const [kenList, setKenList] = useState<any[]>([]);
  const [siList, setSiList] = useState<any[]>([]);

  //編集モード
  const mode = '01';

  // ボタン制御
  const [enableDelete, updateEnableDelete] = useState(true);
  const [enableConfirm, updateEnableConfirm] = useState(true);

  // 削除フラグ
  const [deleteFlag, updateDeleteFlag] = useState(0);

  // 都道府県名&市区町村名
  const [kenNm, updateKenNm] = useState('');
  const [siNm, updateSiNm] = useState('');

  // インジケーター表示フラグ
  const [loading, changeLoading] = useState<boolean>(false);

  // 初期化処理
  useEffect(() => {
    const init = async () => {
      // セッション情報とバリデーションチェックの値入力
      form.setFieldsValue({
        tokCd: tokCd,
        tokCd2: tokCd2,
        companyName: companyName,
        manager: manager,
      });

      // APIに渡すパラメーターを設定
      var tokuisakiParams = {
        cd1: tokCd,
        cd2: tokCd2,
        cpCd: companyCode,
        accId: accountId,
      };

      //得意先名取得
      TokuisakiServ.getTokuisaki(tokuisakiParams)
        .then((json) => {
          form.setFieldsValue({
            tokNm: json.data['nam'],
          });
        })
        .catch((error: any) => {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '得意先検索')
          );
        });

      // 県情報を検索するAPIを呼び出しDBから値を取得
      NonyusakiMaintenanceServ.getKenData()
        .then((json) => {
          // 県リストをセット
          setKenList(() => json.data);
        })
        .catch((error: any) => {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '都道府県検索')
          );
        });

      // 新規作成なら削除ボタンを非活性
      if (props.hensyuMode === mode) {
        form.setFieldsValue({
          process: '新規',
        });
        updateEnableConfirm(false);
      } else {
        // 修正なら該当データをセット
        form.setFieldsValue({
          process: '修正',
        });
        // APIに渡すパラメーターを設定
        var fixParams = {
          tokCd: tokCd,
          tokCd2: tokCd2,
          nouCd: props.nouCd,
        };

        // 納入先マスタ情報を検索するAPIを呼び出しDBから値を取得
        NonyusakiMaintenanceServ.getNonyusakiMaintenanceData(fixParams)
          .then((json) => {
            if (json.data === '') {
              notificationInfo('納入先保守', generateMessage(Message.INFO_MASSAGE.INF004));
            } else {
              form.setFieldsValue({
                nouNm: json.data['nouNm'],
                telNo: json.data['telNo'],
                faxNo: json.data['faxNo'],
                yubinNo: json.data['yubinNo'],
                kenCd: json.data['kenCd'],
                adrTyo: json.data['adrTyo'],
                adrBan: json.data['adrBan'],
                tanNm: json.data['tanNm'],
                tantelNo: json.data['tantelNo'],
                mailAdr: json.data['mailAdr'],
                cellmailAdr: json.data['cellmailAdr'],
                koukanNo: json.data['koukanNo'],
                nouMemo: json.data['nouMemo'],
                okuMemo: json.data['okuMemo'],
                kizMemo: json.data['kizMemo'],
                syaMemo: json.data['syaMemo'],
              });
              // 県データがあれば市区町村データ取得
              if (json.data['kenCd'] !== null) {
                if (json.data['kenCd'] !== '') {
                  // APIに渡すパラメーターを設定
                  var siHensyuu = {
                    kenCd: form.getFieldValue('kenCd'),
                  };

                  // 市区町村を検索するAPIを呼び出しDBから値を取得
                  NonyusakiMaintenanceServ.getSiData(siHensyuu)
                    .then((json) => {
                      setSiList(() => json.data);
                    })
                    .catch((error: any) => {
                      notificationError(
                        '納入先保守',
                        generateMessage(Message.ERROR_MASSAGE.ERR999, '市区町村検索')
                      );
                    });
                }
              }
              form.setFieldsValue({
                siCd: json.data['siCd'],
              });
              updateKenNm(json.data['kenNm']);
              updateSiNm(json.data['siNm']);
              updateEnableConfirm(false);
              updateEnableDelete(false);
            }
          })
          .catch((error: any) => {
            notificationError(
              '納入先保守',
              generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先マスタ検索')
            );
          });
      }
    };
    if (props.visibleState) {
      form.resetFields();
      setSiList(() => []);
      updateDeleteFlag(0);
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visibleState]);

  // 検索処理
  const dataSearch = () => {
    let data = form.getFieldsValue();

    // 画面に入力された条件
    var yubinNo = data.yubinNo || '';

    // APIに渡すパラメーターを設定
    var addressParams = {
      yubinNo,
    };

    // 住所を検索するAPIを呼び出しDBから値を取得
    NonyusakiMaintenanceServ.getAddressData(addressParams)
      .then((json) => {
        // 住所が複数取得できた場合
        if (json.data.length >= 2) {
          var tyohuku = true;
          // 取得した都道府県が一致しているか調査
          for (var i = 1; i < json.data.length; i++) {
            if (json.data[0]['kenCd'] !== json.data[i]['kenCd']) {
              tyohuku = false;
            }
          }
          // 一致している場合フォームにセット
          if (tyohuku) {
            // APIに渡すパラメーターを設定
            var kenParams = {
              kenCd: json.data[0]['kenCd'],
            };

            // 市区町村を検索するAPIを呼び出しDBから値を取得
            NonyusakiMaintenanceServ.getSiData(kenParams)
              .then((json) => {
                setSiList(() => json.data);
              })
              .catch((error: any) => {
                notificationError(
                  '納入先保守',
                  generateMessage(Message.ERROR_MASSAGE.ERR999, '市区町村検索')
                );
              });

            // 県名取得
            updateKenNm(kenList[Number(form.getFieldValue('kenCd')) - 1]['kenNm']);

            // 取得した市区町村が一致しているか調査
            for (var j = 1; j < json.data.length; j++) {
              if (json.data[0]['siCd'] !== json.data[j]['siCd']) {
                tyohuku = false;
              }
            }

            // 一致している場合フォームにセット
            if (tyohuku) {
              // 市区町村をセット
              form.setFieldsValue({
                siCd: json.data[0]['siCd'],
              });

              // 取得した住所１が一致しているか調査
              for (var k = 1; k < json.data.length; k++) {
                if (json.data[0]['adrTyo'] !== json.data[k]['adrTyo']) {
                  tyohuku = false;
                }
              }

              // 一致している場合フォームにセット
              if (tyohuku) {
                // 住所１をセット
                form.setFieldsValue({
                  adrTyo: json.data[0]['adrTyo'],
                });
              } else {
                // 一致しない場合住所1をリセット
                form.resetFields(['adrTyo']);
              }
            } else {
              // 一致しない場合市区町村と住所1をリセット
              form.resetFields(['siCd', 'adrTyo']);
            }
          } else {
            // 一致しない場合都道府県、市区町村と住所1をリセット
            form.resetFields(['kenCd', 'siCd', 'adrTyo']);
          }
        } else if (json.data.length === 1) {
          // APIに渡すパラメーターを設定
          var allSetParams = {
            kenCd: json.data[0]['kenCd'],
          };
          // 市区町村を検索するAPIを呼び出しDBから値を取得
          NonyusakiMaintenanceServ.getSiData(allSetParams)
            .then((json) => {
              setSiList(() => json.data);
            })
            .catch((error: any) => {
              notificationError(
                '納入先保守',
                generateMessage(Message.ERROR_MASSAGE.ERR999, '市区町村検索')
              );
            });
          // 県・市区町村・住所の順でセット
          form.setFieldsValue({
            kenCd: json.data[0]['kenCd'],
            siCd: json.data[0]['siCd'],
            adrTyo: json.data[0]['adrTyo'],
          });
          // 県名取得
          updateKenNm(kenList[Number(form.getFieldValue('kenCd')) - 1]['kenNm']);
        } else {
          notificationInfo('納入先保守', generateMessage(Message.INFO_MASSAGE.INF004));
          // 間違っている可能性があるので全てリセット
          form.resetFields(['kenCd', 'siCd', 'adrTyo']);
        }
      })
      .catch((error) => {
        notificationError('納入先保守', generateMessage(Message.ERROR_MASSAGE.ERR999, '住所検索'));
      });
  };

  // 都道府県の選択を変更
  const changeKen = () => {
    if (form.getFieldValue('kenCd') !== '') {
      // 県名取得
      updateKenNm(kenList[Number(form.getFieldValue('kenCd')) - 1]['kenNm']);

      // APIに渡すパラメーターを設定
      var siParams = {
        kenCd: form.getFieldValue('kenCd'),
      };

      // 市区町村を検索するAPIを呼び出しDBから値を取得
      NonyusakiMaintenanceServ.getSiData(siParams)
        .then((json) => {
          setSiList(() => json.data);
        })
        .catch((error: any) => {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '市区町村検索')
          );
        });
    }
    form.resetFields(['siCd']);
  };

  // 市区町村の選択を変更
  const changeSi = () => {
    // 市区町村名取得
    for (var i = 0; i < siList.length; i++) {
      if (siList[i]['siCd'] === form.getFieldValue('siCd')) {
        updateSiNm(siList[i]['siNm']);
      }
    }
  };

  // 市区町村コードをセットしたときの処理
  useEffect(() => {
    if (form.getFieldValue('siCd') !== undefined) {
      changeSi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siList]);

  // 削除チェック処理
  const dataDeleteCheck = () => {
    updateDeleteFlag(1);
  };

  // 削除フラグに1をセットしたときの処理
  useEffect(() => {
    if (deleteFlag === 1) {
      // APIに渡すパラメーターを設定
      var deleteParams = {
        tokCd,
        tokCd2,
        nouCd: props.nouCd,
        delFlg: deleteFlag,
        updDt: new Date().toLocaleString(),
        updUserId: sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '',
      };

      // テーブル情報を検索するAPIを呼び出しDBを更新
      NonyusakiMaintenanceServ.deleteNonyusakiMaintenanceData(deleteParams).then((json) => {
        if (json.data['rsltCd'] === Const.RESULT_CODE.SUCCESS) {
          notificationSuccess('納入先保守', generateMessage(Message.INFO_MASSAGE.INF007, '納入先'));
          props.closeNonyusakiMaintenance();
        } else if (json.data['rsltCd'] === Const.RESULT_CODE.SYSTEM_ERR) {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先保守')
          );
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFlag]);

  // DB更新前チェック処理
  const dataBaseCheck = () => {
    // バリデーションチェックがOKなら処理をする
    form.validateFields().then(async () => {
      if (loading) return;
      changeLoading(true);
      let data = form.getFieldsValue();

      // APIに渡すパラメーターを設定
      var tokuisakiCheckParams = {
        cd1: data.tokCd || '',
        cd2: data.tokCd2 || '',
        cpCd: companyCode,
        accId: accountId,
      };

      //得意先存在チェック
      await TokuisakiServ.getTokuisaki(tokuisakiCheckParams)
        .then(async (json) => {
          if (json.data.length !== 0) {
            // 画面に入力された条件
            var tokCd = data.tokCd || '';
            var tokCd2 = data.tokCd2 || '';
            var koukanNo = data.koukanNo || '';

            //　工事管理番号が入力されているとき存在チェック
            if (data.koukanNo !== undefined) {
              if (data.koukanNo !== '') {
                // APIに渡すパラメーターを設定
                var koukanNoParams = {
                  tokCd,
                  tokCd2,
                  koukanNo,
                };

                await NonyusakiMaintenanceServ.getKoukanNoData(koukanNoParams)
                  .then((json) => {
                    if (json.data.length !== 0) {
                      dataUpdate();
                    } else {
                      notificationInfo(
                        '納入先保守',
                        generateMessage(Message.INFO_MASSAGE.INF005, '工事管理番号')
                      );
                    }
                  })
                  .catch((error) => {
                    notificationError(
                      '納入先保守',
                      generateMessage(Message.ERROR_MASSAGE.ERR999, '工事管理番号確認')
                    );
                  });
              } else {
                dataUpdate();
              }
            } else {
              dataUpdate();
            }
          } else {
            notificationInfo('納入先保守', generateMessage(Message.INFO_MASSAGE.INF005, '得意先'));
          }
        })
        .catch((error: any) => {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '得意先確認')
          );
        });
      changeLoading(false);
    });
  };

  // DB更新処理
  const dataUpdate = () => {
    let data = form.getFieldsValue();
    // 画面に入力された条件
    var tokCd = data.tokCd || '';
    var tokCd2 = data.tokCd2 || '';
    var nouNm = data.nouNm || '';
    var telNo = data.telNo || '';
    var faxNo = data.faxNo || '';
    var mailAdr = data.mailAdr || '';
    var cellmailAdr = data.cellmailAdr || '';
    var yubinNo = data.yubinNo || '';
    var kenCd = data.kenCd || '';
    var siCd = data.siCd || '';
    var adrTyo = data.adrTyo || '';
    var adrBan = data.adrBan || '';
    var tanNm = data.tanNm || '';
    var tantelNo = data.tantelNo || '';
    var koukanNo = data.koukanNo || '';
    var nouMemo = data.nouMemo || '';
    var okuMemo = data.okuMemo || '';
    var kizMemo = data.kizMemo || '';
    var syaMemo = data.syaMemo || '';
    var delFlg = deleteFlag;

    // 分岐処理
    if (props.hensyuMode === mode) {
      // 新規登録に必要な条件
      var insDt = new Date().toLocaleString();
      var insUserId = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '';

      // APIに渡すパラメーターを設定
      var insertParams = {
        tokCd,
        tokCd2,
        nouNm,
        telNo,
        faxNo,
        mailAdr,
        cellmailAdr,
        yubinNo,
        kenCd,
        siCd,
        kenNm: kenNm,
        siNm: siNm,
        adrTyo,
        adrBan,
        tanNm,
        tantelNo,
        koukanNo,
        nouMemo,
        okuMemo,
        kizMemo,
        syaMemo,
        delFlg,
        insDt,
        insUserId,
      };

      // SEQを取得し、新規登録するAPIを呼び出しDBから値を取得
      NonyusakiMaintenanceServ.insertNonyusakiMaintenanceData(insertParams).then((json) => {
        if (json.data['rsltCd'] === Const.RESULT_CODE.SUCCESS) {
          notificationSuccess('納入先保守', generateMessage(Message.INFO_MASSAGE.INF008, '納入先'));
          props.closeNonyusakiMaintenance();
        } else if (json.data['rsltCd'] === Const.RESULT_CODE.SYSTEM_ERR) {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先登録')
          );
        }
      });
    } else {
      // APIに渡すパラメーターを設定
      var updateDBParams = {
        tokCd: tokCd,
        tokCd2: tokCd2,
        nouCd: props.nouCd,
        delFlg: 0,
      };

      // 更新できるかどうかDB存在チェック
      NonyusakiMaintenanceServ.getNonyusakiMaintenanceData(updateDBParams)
        .then((json) => {
          if (json.data === '') {
            notificationError('納入先保守', generateMessage(Message.ERROR_MASSAGE.ERR013));
          } else {
            // 更新時に必要な値
            var updDt = new Date().toLocaleString();
            var updUserId = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID) ?? '';

            // APIに渡すパラメーターを設定
            var updateParams = {
              tokCd,
              tokCd2,
              nouCd: props.nouCd,
              nouNm,
              telNo,
              faxNo,
              mailAdr,
              cellmailAdr,
              yubinNo,
              kenCd,
              siCd,
              kenNm: kenNm,
              siNm: siNm,
              adrTyo,
              adrBan,
              tanNm,
              tantelNo,
              koukanNo,
              nouMemo,
              okuMemo,
              kizMemo,
              syaMemo,
              updDt,
              updUserId,
            };

            // テーブル情報を検索するAPIを呼び出しDBを更新
            NonyusakiMaintenanceServ.updateNonyusakiMaintenanceData(updateParams).then((json) => {
              if (json.data['rsltCd'] === Const.RESULT_CODE.SUCCESS) {
                notificationSuccess(
                  '納入先保守',
                  generateMessage(Message.INFO_MASSAGE.INF006, '納入先')
                );
                props.closeNonyusakiMaintenance();
              } else if (json.data['rsltCd'] === Const.RESULT_CODE.SYSTEM_ERR) {
                notificationError(
                  '納入先保守',
                  generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先更新')
                );
              }
            });
          }
        })
        .catch((error: any) => {
          notificationError(
            '納入先保守',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先確認')
          );
        });
    }
  };

  return (
    <>
      <Modal closable={false} width={1000} visible={props.visibleState} footer={null}>
        <Spin spinning={loading}>
          <Header screenName={'納入先保守'} />
          <Form
            form={form}
            layout="horizontal"
            autoComplete="off"
            style={{ backgroundColor: '#e6f7ff' }}
          >
            {/* 処理からログインIDまで */}
            <Row
              style={{
                backgroundColor: '#69c0ff',
                height: '50px',
                paddingTop: '8px',
              }}
            >
              <Col offset={1} lg={1} xs={2}>
                <Form.Item label="処理"></Form.Item>
              </Col>
              <Col md={2} xs={3}>
                <Form.Item name={'process'}>
                  <Input className="clsReadOnly" readOnly={true} />
                </Form.Item>
              </Col>
              <Col offset={1} lg={2} md={3} xs={4}>
                <Form.Item label="ログインID"></Form.Item>
              </Col>
              <Col lg={8} md={10} xs={9}>
                <Form.Item name={'companyName'}>
                  <Input className="clsReadOnly" maxLength={20} readOnly={true} />
                </Form.Item>
              </Col>
              <Col md={5} xs={4}>
                <Form.Item name={'manager'}>
                  <Input className="clsReadOnly" maxLength={10} readOnly={true} />
                </Form.Item>
              </Col>
            </Row>

            {/* お得意先様 */}
            <Row style={{ paddingTop: '1vh' }}>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="お得意先様"></Form.Item>
              </Col>
              <Col lg={2} md={3} xs={4}>
                <Form.Item name={'tokCd'}>
                  <Input className="clsReadOnly" maxLength={6} readOnly={true} />
                </Form.Item>
              </Col>
              <Col md={2} xs={3}>
                <Form.Item name={'tokCd2'}>
                  <Input className="clsReadOnly" maxLength={3} readOnly={true} />
                </Form.Item>
              </Col>
              <Col lg={8} sm={11} xs={10}>
                <Form.Item name={'tokNm'}>
                  <Input className="clsReadOnly" maxLength={20} readOnly={true} />
                </Form.Item>
              </Col>
            </Row>

            {/* 納入先名 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item
                  label="納入先名"
                  name={'nouNm'}
                  rules={[{ required: true, message: '' }]}
                ></Form.Item>
              </Col>
              <Col xl={15} lg={16} md={18} sm={18} xs={17}>
                <Form.Item
                  name={'nouNm'}
                  rules={[
                    {
                      required: true,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR001, '納入先名'),
                    },
                  ]}
                >
                  <Input maxLength={40} />
                </Form.Item>
              </Col>
            </Row>

            {/* 郵便番号 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item
                  label="郵便番号"
                  name={'yubinNo'}
                  rules={[{ required: true, message: '' }]}
                ></Form.Item>
              </Col>
              <Col lg={2} md={3} sm={4} xs={5}>
                <Form.Item
                  name={'yubinNo'}
                  rules={[
                    {
                      required: true,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR001, '郵便番号'),
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR018, '郵便番号'),
                    },
                  ]}
                >
                  <Input maxLength={7} />
                </Form.Item>
              </Col>

              {/* 検索ボタン */}
              <Col offset={1}>
                <Form.Item>
                  <Button type="primary" onClick={dataSearch}>
                    <SearchOutlined />
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>

            {/* 都道府県 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item
                  label="都道府県"
                  name={'kenCd'}
                  rules={[{ required: true, message: '' }]}
                ></Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name={'kenCd'}
                  rules={[
                    {
                      required: true,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR001, '都道府県'),
                    },
                  ]}
                >
                  <Select
                    style={{ minWidth: '100px', width: '100%' }}
                    onChange={changeKen}
                    notFoundContent=" "
                  >
                    {kenList.length > 0 &&
                      kenList.map((item, i) => {
                        return (
                          <Option key={i} value={item.kenCd}>
                            {item.kenNm}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* 市区町村 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item
                  label="市区町村"
                  name={'siCd'}
                  rules={[{ required: true, message: '' }]}
                ></Form.Item>
              </Col>
              <Col xl={8} lg={8} md={11} sm={14} xs={17}>
                <Form.Item
                  name={'siCd'}
                  rules={[
                    {
                      required: true,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR001, '市区町村'),
                    },
                  ]}
                >
                  <Select
                    style={{ minWidth: '100px', width: '100%' }}
                    onChange={changeSi}
                    notFoundContent=" "
                  >
                    {siList.length > 0 &&
                      siList.map((item, i) => {
                        return (
                          <Option key={i} value={item.siCd}>
                            {item.siNm}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* 住所1 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item
                  label="住所1"
                  name={'adrTyo'}
                  rules={[{ required: true, message: '' }]}
                ></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item
                  name={'adrTyo'}
                  rules={[
                    {
                      required: true,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR001, '住所1'),
                    },
                  ]}
                >
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 住所2 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="住所2"></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item name={'adrBan'}>
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 電話番号 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="電話番号"></Form.Item>
              </Col>
              <Col lg={4} md={5} sm={7} xs={8}>
                <Form.Item
                  name={'telNo'}
                  rules={[
                    {
                      pattern: /^[0-9-]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR019, '電話番号'),
                    },
                  ]}
                >
                  <Input maxLength={15} />
                </Form.Item>
              </Col>
            </Row>

            {/* FAX番号 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="FAX番号"></Form.Item>
              </Col>
              <Col lg={4} md={5} sm={7} xs={8}>
                <Form.Item
                  name={'faxNo'}
                  rules={[
                    {
                      pattern: /^[0-9-]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR019, 'FAX番号'),
                    },
                  ]}
                >
                  <Input maxLength={15} />
                </Form.Item>
              </Col>
            </Row>

            {/* 現場担当者 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="現場担当者"></Form.Item>
              </Col>
              <Col lg={5} md={6} sm={8} xs={9}>
                <Form.Item name={'tanNm'}>
                  <Input maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

            {/* 現場担当者TEL */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="現場担当者TEL"></Form.Item>
              </Col>
              <Col lg={4} md={5} sm={7} xs={8}>
                <Form.Item
                  name={'tantelNo'}
                  rules={[
                    {
                      pattern: /^[0-9-]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR019, '現場担当者TEL'),
                    },
                  ]}
                >
                  <Input maxLength={15} />
                </Form.Item>
              </Col>
            </Row>

            {/* 携帯mail-add */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="携帯mail-add"></Form.Item>
              </Col>
              <Col lg={12} md={16} sm={18} xs={17}>
                <Form.Item
                  name={'cellmailAdr'}
                  rules={[
                    {
                      pattern: /^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR020, '携帯mail-add'),
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
              </Col>
            </Row>

            {/* mail-add */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="mail-add"></Form.Item>
              </Col>
              <Col lg={12} md={16} sm={18} xs={17}>
                <Form.Item
                  name={'mailAdr'}
                  rules={[
                    {
                      pattern: /^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR020, 'mail-add'),
                    },
                  ]}
                >
                  <Input maxLength={50} />
                </Form.Item>
              </Col>
            </Row>

            {/* 工事管理番号 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="工事管理番号"></Form.Item>
              </Col>
              <Col lg={4} md={5} sm={7} xs={8}>
                <Form.Item
                  name={'koukanNo'}
                  rules={[
                    {
                      pattern: /^[a-zA-Z0-9]+$/,
                      message: generateMessage(Message.ERROR_MASSAGE.ERR017, '工事管理番号'),
                    },
                  ]}
                >
                  <Input maxLength={15} />
                </Form.Item>
              </Col>
            </Row>

            {/* 納入先メモ */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="納入先メモ"></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item name={'nouMemo'}>
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 送り状メモ */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="送り状メモ"></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item name={'okuMemo'}>
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 気付 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="気付"></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item name={'kizMemo'}>
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 車両条件 */}
            <Row>
              <Col offset={1} lg={3} md={4} sm={5} xs={6}>
                <Form.Item label="車両条件"></Form.Item>
              </Col>
              <Col lg={8} md={11} sm={14} xs={17}>
                <Form.Item name={'syaMemo'}>
                  <Input maxLength={20} />
                </Form.Item>
              </Col>
            </Row>

            {/* 格納ボタンから閉じるボタンまで */}
            <Footer
              style={{
                backgroundColor: '#e6f7ff',
                height: '70px',
              }}
            >
              <Row>
                <Col lg={{ offset: 15 }} md={{ offset: 13 }} sm={{ offset: 9 }} xs={{ offset: 5 }}>
                  <Space size={'large'}>
                    <Button
                      type="primary"
                      size={'large'}
                      onClick={dataBaseCheck}
                      disabled={enableConfirm}
                    >
                      確定
                    </Button>
                    <Col offset={5}>
                      <Button
                        type="primary"
                        size={'large'}
                        onClick={dataDeleteCheck}
                        disabled={enableDelete}
                      >
                        削除
                      </Button>
                    </Col>
                    <Col offset={10}>
                      <Button
                        type="primary"
                        onClick={props.closeNonyusakiMaintenance}
                        size={'large'}
                      >
                        閉じる
                      </Button>
                    </Col>
                  </Space>
                </Col>
              </Row>
            </Footer>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default DeliveryMaintenance;
